module.exports = __webpack_public_path__ + "img/michael-lewandowski.4707326f.jpg";